// extracted by mini-css-extract-plugin
export var errorIcon = "_l0-1";
export var nameLogo = "_l0-0";